import type { MouseEventHandler } from 'react'
import React from 'react'
import { Tooltip } from '../TooltipV2'
import type { StyledCommonButtonProps } from './Common.styles'
import { StyledCommonButton } from './Common.styles'

export interface CommonButtonProps extends StyledCommonButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>
  children: JSX.Element
  text: string
  id: string
  ariaLabel: string
  dataTestId?: string
}

export function CommonButton(props: CommonButtonProps): JSX.Element {
  return (
    <>
      <StyledCommonButton
        size={props.size}
        variant={props.variant}
        onClick={props.onClick}
        data-tip
        data-for={props.id}
        data-testid={props.id}
        aria-label={props.ariaLabel}
        onMouseDown={event => {
          event.preventDefault()
        }}
      >
        {props.children}
      </StyledCommonButton>
      <Tooltip id={props.id} place={'top'}>
        {props.text}
      </Tooltip>
    </>
  )
}
